//This variable express that one option different of "All" has been clicked
var tagHasChanged = false;

$(document).ready(function () {

    let productListing = new ProductListing();
    let queryString = new QueryStringProcessor().getUrlParams();
    queryString.elcaproductselector ? productListing.showResults(true, true) : productListing.showResults(false, false);
    //applyCanonicalUrl();

    $("#additionalfilters").hide();

    //UI events

    $(".mi-corpo-product-listing input").on('focusout ', function () {
        productListing.showResults();
        $(".mi-corpo-product-hidden-listing-form input[name='reference']").each(function () {
            $(this).remove();
        });
    });

    $(".mi-corpo-product-listing input").on('keypress ', function (event) {
        if (event.which == 13) {
            productListing.showResults();
            $(".mi-corpo-product-hidden-listing-form input[name='reference']").each(function () {
                $(this).remove();
            });
        }
    });

    $("#showhidefilters").click(function (event) {
        if ($("#showhidefiltersaddremove").html() == "add") {
            $("#showhidefiltersaddremove").text("remove");
            $("#showhidefilterstext").text($("#mi-corpo-product-listing-ElcaProductListingLessFilters-Text").text());
            $("#additionalfilters").show();
            
        }
        else {
            $("#showhidefiltersaddremove").text("add");
            $("#showhidefilterstext").text($("#mi-corpo-product-listing-ElcaProductListingMoreFilters-Text").text());
            $("#additionalfilters").hide();
        }
    });

    $(".mi-corpo-product-listing select").on('change', function (event) {

        if ($(this).val() == 'All') {
            if (tagHasChanged) {
                tagHasChanged = false;
            } else {
                productListing.showResults();
            }
        } else {
            tagHasChanged = true;
            productListing.showResults();
            $(this).val('All').trigger('change');
        }
    });

    applyTechnologyFilter();

});

var ProductListing = function () {
    function generateTags(hasQueryString) {
        processInputBoxes();
        processSelectBoxes();
        if (hasQueryString) {
            processQueryString();
        }
    }

    function processInputBoxes() {
        $(".mi-corpo-product-listing-form input ").each(function () {
            if ($(this).val() !== '' &&
                !valueContainedIn(
                    $(this).val(),
                    $(".mi-corpo-product-hidden-listing-form input")
                )) {

                $(".mi-corpo-product-hidden-listing-form").append(
                    '<input type="hidden" value="' + $(this).val() + '" name="' + $(this).attr('name') + '">'
                );
            }
        });
    }

    function processSelectBoxes() {
        $(".mi-corpo-product-listing-form select ").each(function () {
            if (
                $(this).val() !== 'All' &&
                !valueContainedIn(
                    $(this).val(),
                    $(".mi-corpo-product-hidden-listing-form input")
                )
            ) {
                $(".mi-corpo-product-hidden-listing-form").append(
                    '<input type="hidden" value-name="' + $(this).find('option:selected').text() + '" value="' + $(this).val() + '" name="' + $(this).attr('name') + '">'
                );
            }
        });
    }

    function processQueryString() {

        var queryString = new QueryStringProcessor().getUrlParams();

        if (queryString.elcaproductselector) {

            if (queryString.applications) {

                if ($.isArray(queryString.applications)) {

                    for (let i = 0; i < queryString.applications.length; i++) {
                        var tagId = getTagId(queryString.applications[i], "applications");
                        if (tagId != "") {
                            $(".mi-corpo-product-hidden-listing-form").append(
                                '<input type="hidden" value-name="' + recoverTagName(tagId) + '" value="' + tagId + '" name="applications">'
                            );
                        }
                        
                    }
                } else {
                    var tagId = getTagId(queryString.applications, "applications");
                    if (tagId != "") {
                        $(".mi-corpo-product-hidden-listing-form").append(
                            '<input type="hidden" value-name="' + recoverTagName(tagId) + '" value="' + tagId + '" name="applications">'
                        );
                    }
                }
            }

            if (queryString.productlinescapacityprocessing) {
                if ($.isArray(queryString.productlinescapacityprocessing)) {
                    for (let i = 0; i < queryString.productlinescapacityprocessing.length; i++) {
                        var tagId = getTagId(queryString.productlinescapacityprocessing[i], "productlinescapacityprocessing");
                        if (tagId != "") {
                            $(".mi-corpo-product-hidden-listing-form").append(
                            '<input type="hidden" value-name="' + recoverTagName(tagId) + '" value="' + tagId + '" name="productlinescapacityprocessing">'
                            );
                        }
                    }
                } else {
                    var tagId = getTagId(queryString.productlinescapacityprocessing, "productlinescapacityprocessing");
                    if (tagId != "") {
                        $(".mi-corpo-product-hidden-listing-form").append(
                        '<input type="hidden" value-name="' + recoverTagName(tagId) + '" value="' + tagId + '" name="productlinescapacityprocessing">'
                        );
                    }
                }
            }

            if (queryString.prints) {

                if ($.isArray(queryString.prints)) {

                    for (let i = 0; i < queryString.prints.length; i++) {
                        var tagId = getTagId(queryString.prints[i], "prints");
                        if (tagId != "") {
                            $(".mi-corpo-product-hidden-listing-form").append(
                            '<input type="hidden" value-name="' + recoverTagName(tagId) + '" value="' + tagId + '" name="prints">'
                            );
                        }
                    }
                } else {
                    var tagId = getTagId(queryString.prints, "prints");
                    if (tagId != "") {
                        $(".mi-corpo-product-hidden-listing-form").append(
                        '<input type="hidden" value-name="' + recoverTagName(tagId) + '" value="' + tagId + '" name="prints">'
                        );
                    }
                }
            }

            if (queryString.technologies) {
                if ($.isArray(queryString.technologies)) {
                    for (let i = 0; i < queryString.technologies.length; i++) {
                        var tagId = getTagId(queryString.technologies[i], "technologies");
                        if (tagId != "") {
                            $(".mi-corpo-product-hidden-listing-form").append(
                            '<input type="hidden" value-name="' + recoverTagName(tagId) + '" value="' + tagId + '" name="technologies">'
                            );
                        }
                    }
                } else {
                    var tagId = getTagId(queryString.technologies, "technologies");
                    if (tagId != "") {
                        $(".mi-corpo-product-hidden-listing-form").append(
                        '<input type="hidden" value-name="' + recoverTagName(tagId) + '" value="' + tagId + '" name="technologies">'
                        );
                    }
                }
            }

            if (queryString.industries) {
                if ($.isArray(queryString.industries)) {
                    for (let i = 0; i < queryString.industries.length; i++) {
                        var tagId = getTagId(queryString.industries[i], "industries");
                        if (tagId != "") {
                            $(".mi-corpo-product-hidden-listing-form").append(
                            '<input type="hidden" value-name="' + recoverTagName(tagId) + '" value="' + tagId + '" name="industries">'
                            );
                        }
                    }
                } else {
                    var tagId = getTagId(queryString.industries, "industries");
                    if (tagId != "") {
                        $(".mi-corpo-product-hidden-listing-form").append(
                        '<input type="hidden" value-name="' + recoverTagName(tagId) + '" value="' + tagId + '" name="industries">'
                        );
                    }
                }
            }

            if (queryString.packaginglayers) {
                if ($.isArray(queryString.packaginglayers)) {
                    for (let i = 0; i < queryString.packaginglayers.length; i++) {
                        var tagId = getTagId(queryString.packaginglayers[i], "packaginglayers");
                        if (tagId != "") {
                            $(".mi-corpo-product-hidden-listing-form").append(
                            '<input type="hidden" value-name="' + recoverTagName(tagId) + '" value="' + tagId + '" name="packaginglayers">'
                            );
                        }
                    }
                } else {
                    var tagId = getTagId(queryString.packaginglayers, "packaginglayers");
                    if (tagId != "") {
                        $(".mi-corpo-product-hidden-listing-form").append(
                        '<input type="hidden" value-name="' + recoverTagName(tagId) + '" value="' + tagId + '" name="packaginglayers">'
                        );
                    }
                }
            }

            if (queryString.materialtypes) {
                if ($.isArray(queryString.materialtypes)) {
                    for (let i = 0; i < queryString.materialtypes.length; i++) {
                        var tagId = getTagId(queryString.materialtypes[i], "materialtypes");
                        if (tagId != "") {
                            $(".mi-corpo-product-hidden-listing-form").append(
                            '<input type="hidden" value-name="' + recoverTagName(tagId) + '" value="' + tagId + '" name="materialtypes">'
                            );
                        }
                    }
                } else {
                    var tagId = getTagId(queryString.materialtypes, "materialtypes");
                    if (tagId != "") {
                        $(".mi-corpo-product-hidden-listing-form").append(
                        '<input type="hidden" value-name="' + recoverTagName(tagId) + '" value="' + tagId + '" name="materialtypes">'
                        );
                    }
                }
            }

        }
    }

    function valueContainedIn(value, containingElement) {
        let valueContained = false;

        $(containingElement).each(function () {
            if (value === $(this).attr('value')) {
                valueContained = true;
            }
        });

        return valueContained;
    }

    function changeSelectBoxesValue() {
        var taxonomyTagFileteredCollection = [];

        var applicationsTags = [];
        var productlinescapacityprocessingTags = [];
        var printsTags = [];
        var technologiesTags = [];
        var industriesTags = [];
        var packingLayersTags = [];
        var materialTypesTags = [];


        

        $(".mi-corpo-product-hidden-listing-form input").each(function () {
            if ($(this)[0].id != "pagination") {
                taxonomyTagFileteredCollection.push($(this));
            }
        });

        $.each(taxonomyTagFileteredCollection, function (index, element) {
            switch ($(element)[0].getAttribute("name")) {
                case "applications":
                    applicationsTags.push($(element)[0].getAttribute("value-name"));
                    break;
                case "productlinescapacityprocessing":
                    productlinescapacityprocessingTags.push($(element)[0].getAttribute("value-name"));
                    break;
                case "prints":
                    printsTags.push($(element)[0].getAttribute("value-name"));
                    break;
                case "technologies":
                    technologiesTags.push($(element)[0].getAttribute("value-name"));
                    break;
                case "industries":
                    industriesTags.push($(element)[0].getAttribute("value-name"));
                    break;
                case "packaginglayers":
                    packingLayersTags.push($(element)[0].getAttribute("value-name"));
                    break;
                case "materialtypes":
                    materialTypesTags.push($(element)[0].getAttribute("value-name"));
                    break;
            }
        });
        var allTranslation = $("#mi-corpo-product-listing-ElcaAll-Text").text();

        if (applicationsTags.length <= 0) {
            applicationsTags.push(allTranslation);
        }
        if (productlinescapacityprocessingTags.length <= 0) {
            productlinescapacityprocessingTags.push(allTranslation);
        }
        if (printsTags.length <= 0) {
            printsTags.push(allTranslation);
        }
        if (technologiesTags.length <= 0) {
            technologiesTags.push(allTranslation);
        }
        if (industriesTags.length <= 0) {
            industriesTags.push(allTranslation);
        }
        if (packingLayersTags.length <= 0) {
            packingLayersTags.push(allTranslation);
        }
        if (materialTypesTags.length <= 0) {
            materialTypesTags.push(allTranslation);
        }

        $("select[id='applications']").children('option:first').text(applicationsTags.join(", "));
        $("select[id='applications']").val('All');
        $("select[id='productlinescapacityprocessing']").children('option:first').text(productlinescapacityprocessingTags.join(", "));
        $("select[id='productlinescapacityprocessing']").val('All');
        $("select[id='prints']").children('option:first').text(printsTags.join(", "));
        $("select[id='prints']").val('All');
        $("select[id='technologies']").children('option:first').text(technologiesTags.join(", "));
        $("select[id='technologies']").val('All');
        $("select[id='industries']").children('option:first').text(industriesTags.join(", "));
        $("select[id='industries']").val('All');
        $("select[id='packaginglayers']").children('option:first').text(packingLayersTags.join(", "));
        $("select[id='packaginglayers']").val('All');
        $("select[id='materialtypes']").children('option:first').text(materialTypesTags.join(", "));
        $("select[id='materialtypes']").val('All');
    }

    return {
        showResults: function (hasQueryString = false, tags = true, page = 1) {

            if (tags) {
                generateTags(hasQueryString);
            }
            var language = $('html').attr('lang');

            changeSelectBoxesValue();

            var queryString = "?" +
                $(".mi-corpo-product-hidden-listing-form").serialize() +
                ($(".mi-corpo-product-listing-page") ? "&page=" + page : "1");

            var requestManager = new AsyncRequestManager();
            var technologyFilter = $("#mi-corpo-product-listing-TechnologyFilter").text();
            var fileButtonLabel = $("#mi-corpo-product-listing-FileButtonLabel").text();
            var fileButtonCss = $("#mi-corpo-product-listing-FileButtonCss").text();
            var linkButtonLabel = $("#mi-corpo-product-listing-LinkButtonLabel").text();
            var linkButtonCss = $("#mi-corpo-product-listing-LinkButtonCss").text();
            var linkButtonPath = $("#mi-corpo-product-listing-LinkButtonPath").text();

            if (!designMode()) {
                requestManager.renderAsyncRequestProductListing('/product-listing/search', queryString, '#mi-corpo-product-listing-display-results', false, language,
                    technologyFilter, fileButtonLabel, fileButtonCss, linkButtonLabel, linkButtonCss, linkButtonPath);
            }
        },

        removeTag: function (tagToBeRemoved) {

            var tagValue = $(tagToBeRemoved).parent().children("span.float-left").children("input").val();
            return document.querySelectorAll("input[value='" + tagValue + "']");
        }
    }

    function designMode() {
        var url = window.location.href; 
        if (url.includes("Action/Edit") || url.includes("action/edit") ) {
            return true;
        }
        return false;
    }

    function getTagId(tag, taxonomy) {
        var language = $('html').attr('lang');
        return $.ajax({
            url: "/product-listing/get-tag-id-by-name",
            async: false,
            data: {tag: tag, taxonomy: taxonomy, language: language},
            type: "PUT",
        }).responseText;
    }

    function recoverTagName(tagId) {
        var language = $('html').attr('lang');
        return $.ajax({
            url: "/product-listing/get-tag-name-by-id",
            async: false,
            data: { tagId: tagId, language: language},
            type: "PUT",
        }).responseText;

    }

    
    
};


function applyTechnologyFilter() {
    var technologyFilter = $("#mi-corpo-product-listing-TechnologyFilter").text();

    if (technologyFilter != "") {
        var filterId = getTagId(technologyFilter, "technologies");
        if (filterId != "") {
            $("#technologies").val(filterId);
            $("#technologies").change();
            $("#technologies").parent().hide();

        }
    }
}





//This method will check if the last url occurrence match with any technology filter.
function applyCanonicalUrl() {
    var lastParam = getLastPartOfUrl();
    var filterId = getTagId(lastParam, "technologies");
    if (filterId != "") {
        $("#technologies").val(filterId);
        $("#technologies").change();
    }
    
}

function getLastPartOfUrl() {
    let url = $(location).attr('href');
    var urlsplit = url.split("/");
    var lastpart = urlsplit[urlsplit.length - 1];
    if (lastpart === '') {
        lastpart = urlsplit[urlsplit.length - 2];
    }
    return lastpart;
}

function getTagId(tag, taxonomy) {
    var language = $('html').attr('lang');
    return $.ajax({
        url: "/product-listing/get-tag-id-by-name",
        async: false,
        data: { tag: tag, taxonomy: taxonomy, language: language },
        type: "PUT",
    }).responseText;
}
